import { fetcher } from '@commenda/utils';

export async function startFlattenPDFJob(
  jobId: string
): Promise<Response | null> {
  try {
    const res = await fetcher(`document-processing-job/${jobId}/start`, {
      method: 'POST',
    });

    return res;
  } catch (err) {
    console.error('Error starting flatten PDF job:', err);
    return null;
  }
}
